import { render, staticRenderFns } from "./Lgx196046153584738304.vue?vue&type=template&id=3121a236&scoped=true&"
import script from "./Lgx196046153584738304.vue?vue&type=script&lang=js&"
export * from "./Lgx196046153584738304.vue?vue&type=script&lang=js&"
import style0 from "./Lgx196046153584738304.vue?vue&type=style&index=0&id=3121a236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121a236",
  null
  
)

export default component.exports